/* Imperia wishlist — localStorage-backed favourites */
(function () {
  var KEY = 'imperia-wishlist';

  function list() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(l) { localStorage.setItem(KEY, JSON.stringify(l)); sync(); }
  function has(h) { return list().indexOf(h) !== -1; }

  function sync() {
    document.querySelectorAll('.imperia-wish-btn').forEach(function (b) {
      b.classList.toggle('is-active', has(b.getAttribute('data-handle')));
    });
    var t = String(list().length);
    document.querySelectorAll('.imperia-wish-count').forEach(function (c) {
      if (c.textContent !== t) c.textContent = t;
      c.classList.toggle('opacity-0', t === '0');
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function heartSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3S3.5 15.1 3.5 9.4a4.6 4.6 0 0 1 8.5-2.5A4.6 4.6 0 0 1 20.5 9.4c0 5.7-8.5 10.9-8.5 10.9Z"></path></svg>';
  }

  function renderFavourites() {
    var root = document.getElementById('imperia-favourites');
    if (!root) return;
    var l = list();
    var empty = root.querySelector('.imperia-favs__empty');
    var grid = root.querySelector('.imperia-favs__grid');
    if (!grid) return;
    grid.innerHTML = '';
    if (!l.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;

    l.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?width=500' : '&width=500') : '';
          var card = document.createElement('div');
          card.className = 'imperia-fav-card';
          card.innerHTML =
            '<button type="button" class="imperia-wish-btn is-active" data-handle="' + h + '" aria-label="Remove from favourites">' + heartSvg() + '</button>' +
            '<a href="' + p.url + '" class="imperia-fav-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<a href="' + p.url + '" class="imperia-fav-card__title">' + p.title + '</a>' +
            '<a href="' + p.url + '" class="imperia-buy-bar__button"><span>' + money(p.price) + '</span><span class="imperia-buy-bar__plus" aria-hidden="true">+</span></a>';
          grid.appendChild(card);
        })
        .catch(function () { /* product no longer available; drop it silently */ });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.imperia-wish-btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-handle');
    var l = list();
    var i = l.indexOf(h);
    if (i === -1) { l.push(h); } else { l.splice(i, 1); }
    save(l);
    if (document.getElementById('imperia-favourites')) renderFavourites();
  });

  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  });

  function init() {
    sync();
    renderFavourites();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
